
import api from "@/api/index"; //ABP API接口
import { Vue, Component, Ref } from "vue-property-decorator";
import { ElementTableView } from "@/lib/ElementTableView";

import { MessageBox } from "element-ui";
import enumFilter from "@/mixins/filters/enums";

import { UserDto } from "@/api/appService";
import EditUser from "./components/edit-user.vue";

@Component({
  name: "UserList",
  components: { EditUser },
  mixins: [enumFilter]
})
export default class UserList extends ElementTableView {
  @Ref() editForm!: EditUser;
  tableItems: UserDto[] = [];
  showEditUser = false

  async created() {
    await this.fetchData();
  }

  // 获取表数据
  async fetchData() {
    this.table.listLoading = true;
    await api.user
      .getAll({
        keyword: this.queryForm.keyword,
        sorting: this.table.sorting,
        maxResultCount: this.table.pagesize,
        skipCount: this.skipCount
      })
      .then(res => {
        console.log(res);
        this.table.listLoading = false;
        this.tableItems = res.items!;
        this.table.totalCount = res.totalCount!;
      });
  }

  // 查看详情
  handleViewDetail(index: number, row: any) {
    this.$router.push({
      name: "user-detail",
      params: { id: row.id }
    });
  }

  // 新建
  handleCreate() {
    this.showEditUser = true;
  }

  // 编辑
  handleEdit(index: number, row: UserDto) {
    this.editForm.form.user = row;
    this.showEditUser = true;

    console.warn("%cu must reWrite this method", "color:#0048BA;");
  }

  // 删除
  async handleDelete(index: number, row: UserDto) {
    this.$confirm("你确定删除吗?", "提示").then(async () => {
      await api.user.delete({ id: row.id }).then(res => {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.fetchData();
      });
    });
  }

  // 更新当前页
  async current_change(e: number) {
    this.table.page = e;
    await this.fetchData();
  }

  // Table排序
  async sort(e: any) {
    console.log("sort : ", e);
    if (e.prop && e.order) {
      this.table.sorting = `${e.prop} ${e.order}`;
    }
    await this.fetchData();
  }

  // 修改一页显示的条目
  async handleSizeChange(e: number) {
    this.table.pagesize = e;
    await this.fetchData();
  }

  // 搜索
  async handleSearch() {
    await this.fetchData();
  }

  // 重置搜索
  async handleResetSearch() {
    this.queryForm = {
      keyword: "",
      from: undefined,
      to: undefined,
      isActive: undefined
    };
    await this.fetchData();
  }

  async handelOnSaved() {
    await this.fetchData();
  }
}
